export const parseJwtPayload = (token) => {
  const payloadPart = token && token.split('.')[1];

  if (!payloadPart) {
    throw new Error('invalid jwt format');
  }

  return JSON.parse(Buffer.from(payloadPart, 'base64').toString());
};